import React from 'react'
import LogoHeader from '../../components/login/includes/LogoHeader'
import ContentLayout from '../../components/ContentLayout/ContentLayout'
import AppRoutes from '../../routes/appRoutes'

const TermsAndConditionsPage = () => {
    return (
        <ContentLayout>
            <div className="mx-40 my-8">
                <LogoHeader />
                <p className="my-4">
                    <i>Effective as of January 1, 2023</i>
                </p>

                <p className="mb-2">
                    Welcome to one of the websites (“Site”) of Weisiger Group
                    Inc and its subsidiaries and affiliates, including LiftOne
                    LLC (“Company,” “we,” “our,” or “us”). Please read the
                    following terms and conditions carefully as they govern your
                    use of this Site.
                </p>

                <h1 className="font-bold text-lg my-4">Terms of Use</h1>
                <ul className="list-decimal px-12 mb-4">
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Introduction.</b> The Site on which this Terms of
                            Use appears is owned and operated by us. For
                            purposes of these Terms of Use, “you” or “your”
                            means the person accessing the Site and any persons
                            that allow others to provide information about
                            themselves to us.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Binding Agreement.</b> THESE TERMS OF USE
                            CONSTITUTE A BINDING AGREEMENT BETWEEN YOU AND US.
                            PLEASE READ CAREFULLY THROUGH ALL SECTIONS OF THESE
                            TERMS OF USE. YOUR ACCESS TO AND USE OF THE SITE IS
                            SUBJECT TO THESE TERMS OF USE AND ALL APPLICABLE
                            LAWS AND WE RESERVE THE RIGHT TO TERMINATE YOUR
                            ACCESS TO THE SITE IF YOU VIOLATE THESE TERMS OF
                            USE. BY CLICKING ON LINKS WITHIN THE SITE OR
                            WEBPAGES BEYOND THE SITE’S HOMEPAGE OR BY CLICKING
                            ON A BOX OR ICON YOU AGREE TO THESE TERMS OF USE
                            WHETHER OR NOT YOU COMPLETE A TRANSACTION WITH US
                            AND WHETHER OR NOT YOU COMPLETE YOUR TRANSACTION ON
                            THE SITE OR THROUGH OTHER CHANNELS, SUCH AS BY
                            TELEPHONE, EMAIL, FACSIMILE, OR OTHERWISE. IF YOU DO
                            NOT AGREE WITH THESE TERMS OF USE, DO NOT ACCESS OR
                            OTHERWISE USE THE SITE, ANY SERVICES AVAILABLE
                            THROUGH THE SITE, OR ANY INFORMATION CONTAINED ON
                            THIS SITE.
                        </p>
                        <p className="mb-2">
                            <b>
                                MANDATORY ARBITRATION NOTICE AND CLASS ACTION
                                AND JURY TRIAL WAIVER.
                            </b>{' '}
                            These Terms of Use contain a mandatory (binding)
                            arbitration provision and class action and jury
                            trial waiver clauses. Except for certain types of
                            disputes described in the arbitration section below
                            or where prohibited by applicable law, you agree
                            that disputes between you and us regarding your use
                            of the Site or services will be resolved by binding,
                            individual arbitration and you waive your right to
                            participate in a class action lawsuit or class-wide
                            arbitration, including as a class representative.
                            The arbitrator’s decision will be subject to very
                            limited review by a court. You will be entitled to a
                            fair hearing, but the arbitration procedures are
                            simpler and more limited than rules applicable in
                            Court. For more details, see below.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Privacy Policy.</b> Besides these Terms of Use,
                            we also publish a{' '}
                            <a
                                href={AppRoutes.privacyPolicy()}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-links hover:underline"
                            >
                                Privacy Policy.
                            </a>{' '}
                            Although it is not part of these Terms of Use, we
                            encourage you to read it to better understand how
                            you can update, manage, access, and delete your
                            information.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Future Changes.</b> Company reserves the right at
                            any time to change or modify the Site, these Terms
                            of Use, our{' '}
                            <a
                                href={AppRoutes.privacyPolicy()}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-links hover:underline"
                            >
                                Privacy Policy.
                            </a>{' '}
                            and any other documents incorporated by reference
                            herein. When changes are made, Company will post the
                            current Terms of Use on the Site. Any use of the
                            Site by a user following such changes shall
                            constitute such user’s acceptance of the changed
                            Terms of Use. You are responsible for regularly
                            reviewing these Terms of Use.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Trademarks, Copyrights & Restrictions.</b> All
                            content on the Site including, but not limited to,
                            content such as text, designs, graphics, logos,
                            interfaces and images, and the collection and
                            arrangement thereof, is protected by copyrights or
                            contains protectable trademarks which are owned or
                            licensed by Company. You may not reproduce, perform,
                            create derivative works from, republish, transmit,
                            or distribute in any way whatsoever any materials
                            from the Site without the prior written permission
                            of Company. However, the preceding restriction does
                            not preclude such automated copying as is necessary
                            for operation of your browser for the purposes of
                            using the Site for its intended purposes, such as
                            caching Site contents or loading the contents into a
                            computer’s RAM. You may also print one copy of the
                            information on the Site for personal use, provided
                            that all copyright and other notices contained in
                            the materials are left intact. You agree not to: (a)
                            use any robot, spider, other automatic device to
                            monitor or copy portions of the Site or the content
                            contained herein without Company’s prior written
                            permission; (b) use any device, software or routine
                            to interfere or attempt to interfere with the proper
                            working of the Site; and (c) download, reproduce,
                            duplicate, copy or otherwise exploit any portion of
                            the Site for the purpose of sale, resale, or making
                            other commercial use thereof. This list of
                            prohibited activities provides examples and is not
                            complete or exclusive. We reserve the right to
                            terminate your ability to use the Site with or
                            without cause, and with or without notice, for any
                            reason or no reason, or for any action that we
                            determine is inappropriate or disruptive to this
                            Site.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Registration Process.</b> To access certain
                            on-line tools and/or to order products (if
                            applicable) through the Site, you must complete a
                            registration process. When completing the applicable
                            registration process, you agree to (a) provide
                            accurate, current, and complete information as
                            required in the registration process and (b) update
                            this information in the future if the information
                            changes.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Minimum Age.</b> By using the Site and/or
                            submitting a product order using the Site you
                            represent and warrant that you are at least eighteen
                            (18) years old.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Submissions.</b> Company values your feedback and
                            suggestions to improve our services and Site. We do
                            not, however, wish to receive any proprietary or
                            confidential information from you by electronic mail
                            or through our Site. If you choose to make a
                            submission or send an email message to us, then by
                            doing so you (a) represent to us that the material
                            submitted in the message is not confidential or
                            proprietary and (b) agree that Company has no
                            obligation with respect to the materials or
                            suggestions and that Company is free to copy,
                            disclose, incorporate, republish and otherwise use
                            or distribute the materials or suggestions submitted
                            by use without providing payment or attribution to
                            you. By forwarding any content or communications to
                            us through the Site or by other electronic means,
                            you thereby grant us a perpetual, royalty-free,
                            fully paid-up, world-wide, irrevocable,
                            non-exclusive, freely transferable, and freely
                            sublicensable license to use, reproduce, modify,
                            adapt, publish, translate, create derivative works
                            from, redistribute, and display such content and
                            communications in any form for the purposes of
                            providing the services and any purpose tangentially
                            related to the services. No compensation will be
                            paid to you with respect to our or our sublicensees’
                            use of your communications. By providing or
                            submitting content, you represent and warrant that
                            you own or otherwise control all of the rights to
                            your submitted content and communications as
                            described in this section, including all the rights
                            necessary for you to submit the content and
                            communications and grant the license above.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Copyright Complaints. </b> Company respects the
                            intellectual property of others. If you believe that
                            your work has been copied in a way that constitutes
                            copyright infringement, please contact us through
                            the contact information provided in this Terms of
                            Use.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Links.</b> As a service to you, the Site includes
                            links to websites operated by third parties. By
                            providing links to third-party websites, Company is
                            not endorsing or sponsoring such third parties or
                            their websites. You agree that Company is not
                            responsible for the availability of or content on
                            any websites operated by third parties that may be
                            accessible through or linked to the Site. We provide
                            links to third-party websites as a convenience, and
                            we do not verify, make any representations, or take
                            responsibility for such third-party websites,
                            including the truthfulness, accuracy, quality, or
                            completeness of the content, services, links
                            displayed and/or any other activities conducted on
                            or through such third-party websites. We recommend
                            that you read and understand the terms of use and
                            privacy policies of each linked website that you
                            visit. YOU AGREE THAT WE WILL NOT, UNDER ANY
                            CIRCUMSTANCES, BE RESPONSIBLE OR LIABLE, DIRECTLY OR
                            INDIRECTLY, FOR ANY GOODS, SERVICES, INFORMATION,
                            RESOURCES, AND/OR CONTENT AVAILABLE ON OR THROUGH
                            ANY THIRD-PARTY WEBSITES AND/OR THIRD-PARTY DEALINGS
                            OR COMMUNICATIONS, OR FOR ANY HARM RELATED THERETO,
                            OR ANY DAMAGES OR LOSSES CAUSED OR ALLEGED TO BE
                            CAUSED BY OR IN CONNECTION WITH YOUR USE OR RELIANCE
                            ON THE CONTENT OR BUSINESS PRACTICES OF ANY THIRD
                            PARTY.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>SMS Text Messaging.</b> By signing up to receive
                            promotional messages from Company, you are
                            consenting to receive ongoing marketing text
                            messages, that may be sent via an automatic
                            telephone dialing system, by or on behalf of
                            Company, its affiliates, agents and third-party
                            service providers authorized to act on behalf of
                            Company to the cellular number you provided. You may
                            also receive confirmatory texts regarding enrollment
                            and requests to unsubscribe should you elect to text
                            STOP to 36582 or contact Company at
                            info@carolinacat.com as directed to opt out or
                            revoke your consent. Consent to receive texts is not
                            a condition of purchase. For questions, text HELP to
                            36582 at any time. To opt in, text Cat to 36582 or
                            visit{' '}
                            <a
                                href="https://carolinacat.com/construction/sms-text-opt-in"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-links hover:underline"
                            >
                                Carolina Cat SMS text options.
                            </a>{' '}
                            Company promotional messages are compatible with a
                            variety of mobile carriers. Message frequencies may
                            vary. Message and data rates may apply through your
                            cellular carrier. Check your cellular plan for more
                            details. If you have any questions regarding
                            privacy, please read our{' '}
                            <a
                                href={AppRoutes.privacyPolicy()}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-links hover:underline"
                            >
                                Privacy Policy.
                            </a>
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Purchase of Product.</b> You may order goods from
                            Company (the “Products”) by placing an order online
                            through the Site. The terms and conditions
                            applicable to the purchase of Products are set forth
                            in Company’s Standard Order Terms and Conditions,
                            which are incorporated by reference herein.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Warranty Disclaimer.</b> THE SITE AND ALL CONTENT
                            ARE PROVIDED “AS-IS,” AND TO THE FULLEST EXTENT
                            ALLOWED BY LAW ALL REPRESENTATIONS AND WARRANTIES,
                            EXPRESS OR IMPLIED, RELATING TO THE SITE OR THE
                            CONTENT ARE DISCLAIMED, INCLUDING ANY IMPLIED
                            WARRANTY OF MERCHANTABILITY, FITNESS FOR A
                            PARTICULAR PURPOSE OR NON-INFRINGEMENT, AS WELL AS
                            ANY WARRANTY OF QUALITY, FUNCTIONALITY, ACCURACY,
                            CURRENCY, COMPLETENESS, RELIABILITY, OPERABILITY,
                            USE, PERFORMANCE, OR ABSENCE OF VIRUSES. YOU ASSUME
                            ALL RESPONSIBILITY AND RISK OF LOSS RESULTING FROM
                            THE USE OF THE SITE. BY PROVIDING THE SERVICES ON
                            THE SITE, WE DO NOT IN ANY WAY PROMISE THAT THE
                            SERVICES WILL REMAIN AVAILABLE TO YOU. WE ARE
                            ENTITLED TO TERMINATE ALL OR PARTY OF ANY OF THE
                            SITE AT ANY TIME, IN OUR SOLE DISCRETION WITHOUT
                            NOTICE TO YOU.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Limitation of Liability.</b> WE CANNOT GUARANTEE
                            THE SITE WILL BE AVAILABLE ONE HUNDRED PERCENT
                            (100%) OF THE TIME BECAUSE PUBLIC NETWORKS, SUCH AS
                            THE INTERNET OCCASSIONALLY EXPERIENCE DISRUPTIONS.
                            ALTHOUGH WE STRIVE TO PROVIDE A RELIABLE SITE,
                            INTERRUPTIONS AND DELAYS IN ACCESSING THE SITE ARE
                            UNAVOIDABLE AND WE DISCLAIM ANY LIABILITY FOR
                            DAMAGES RESULTING FROM SUCH PROBLEMS. IN NO EVENT
                            SHALL COMPANY OR ITS AFFILIATES BE LIABLE FOR ANY
                            DAMAGES WHATSOEVER ARISING FROM YOUR USE, INABILITY
                            TO USE, TIMELINESS OF USE OR RELIANCE UPON THE SITE
                            OR OF ANY WEBSITE LINKED TO OR ACCESSED THROUGH THIS
                            SITE, WHETHER ARISING IN CONTRACT, TORT OR
                            OTHERWISE, INCLUDING SPECIAL, INDIRECT,
                            CONSEQUENTIAL, INCIDENTAL OR PUNITIVE DAMAGES, EVEN
                            IF COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF
                            THOSE DAMAGES.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Indemnity.</b> You agree to indemnify, defend and
                            hold Company, and our subsidiaries, affiliates,
                            officers, members, agents or other partners, and
                            employees, harmless from any claim or demand,
                            including reasonable attorneys’ fees, made by any
                            third party due to or arising out of content you
                            submit, post to or transmit through the Site, your
                            use of the Site, your connection to the Site, your
                            violation of these Terms of Use, or your violation
                            of any rights of another.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Injunctive Relief.</b> You acknowledge that we
                            may be irreparably damaged if these Terms of Use are
                            not specifically enforced, and damages at law would
                            be an inadequate remedy. Therefore, in the event of
                            a breach or threatened breach of any provision of
                            these Terms of Use by you, we shall be entitled,
                            without prejudice to any other rights and remedies
                            that may be sought under the mandatory arbitration
                            provision of these Terms of Use, to an injunction
                            restraining such breach or threatened breach,
                            without being required to show any actual damage or
                            to post an injunction bond, and/or to a decree for
                            specific performance of the provisions of these
                            Terms of Use. For purposes of this Section, you
                            agree that any action or proceeding with regard to
                            such injunction restraining such breach or
                            threatened breach shall be brought in the state or
                            federal courts located in North Carolina. You
                            consent to the jurisdiction of such court and waive
                            any objection to the laying of venue of any such
                            action or proceeding in such court. You agree that
                            service of any court paper may be effected on such
                            party by mail or in such other manner as may be
                            provided under applicable laws, rules of procedure
                            or local rules.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Governing Law.</b> Your use of the Site shall be
                            governed by and construed in accordance with the
                            laws of the State of North Carolina, without regard
                            to the choice of law provisions thereof. Except as
                            set forth in the agreement to arbitration and
                            without waiving it, you agree that any dispute
                            arising from or relating to the subject matter of
                            these Terms of Use (including but not limited to if
                            you opt out of the agreement to arbitration) shall
                            be governed by the exclusive jurisdiction and venue
                            of the state and federal courts of Charlotte, North
                            Carolina, except where the jurisdiction and venue
                            are mandated by applicable assignment.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>
                                MANDATORY ARBITRATION AND CLASS ACTION AND JURTY
                                TRIAL WAIVER.
                            </b>{' '}
                            Most concerns can be resolved quickly and to your
                            satisfaction by contacting us as set forth in the
                            “Questions” section below.
                        </p>
                        <p className="mb-2">
                            In the event that we are not able to resolve a
                            dispute, and with the exception of the claims for
                            injunctive relief by us as described above and to
                            the extent allowed by law, you hereby agree that
                            either you or we may require any dispute, claim, or
                            cause of action (“Claim”) between you and us or any
                            third parties arising out of use of the Site, the
                            services, and any other actions with us (whether
                            based in contract, tort, statute, fraud,
                            misrepresentation, or any other legal theory) to be
                            arbitrated on an individual (non-class) basis.
                            However, both parties retain the right to seek
                            relief in a small claims court (or a state court
                            equivalent) for a Claim within the scope of its
                            jurisdiction so long as the small claims action does
                            not seek to certify a class, combine the claims of
                            multiple persons, recover damages in excess of the
                            limit for a small claim under applicable state law
                            or is not transferred, removed, or appealed from
                            small claims court to any different court.
                            Additionally, if you are a California resident, you
                            retain the right to obtain public injunctive relief
                            from any court with proper jurisdiction.
                        </p>
                        <p className="mb-2">
                            <b>
                                THERE IS NO JUDGE OR JURY IN ARBITRATION, AND
                                COURT REVIEW OF AN ARBITRATION AWARD IS VERY
                                LIMITED. ADDITIONALLY, ANY ARBITRATION OF A
                                CLAIM WILL BE ON AN INDIVIDUAL BASIS, AND,
                                THEREFORE, YOU UNDERSTAND AND AGREE THAT YOU ARE
                                WAIVING THE RIGHT TO PARTICIPATE AS A CLASS
                                REPRESENTATIVE OR CLASS MEMBER IN A CLASS ACTION
                                LAWSUIT. AS PART OF THIS WAIVER, YOU AGREE THAT
                                YOU WAIVE THE RIGHT TO ACT AS A PRIVATE ATTORNEY
                                GENERAL IN AN ARBITRATION; THAT EXCEPT AS
                                OTHERWISE PROVIDED IN THIS ARBITRATION
                                AGREEMENT, CLAIMS BROUGHT BY OR AGAINST YOU MAY
                                NOT BE JOINED OR CONSOLIDATED WITH CLAIMS
                                BROUGHT BY OR AGAINST ANY OTHER PERSON; AND THE
                                ARBITRATOR SHALL HAVE NO AUTHORITY TO CONDUCT A
                                CLASS-WIDE ARBITRATION, PRIVATE ATTORNEY GENERAL
                                ARBITRATION OR MULTIPLE-PARTY ARBITRATION.
                            </b>
                        </p>
                        <p className="mb-2">
                            You and we agree that your use of the services
                            involves interstate commerce, and that this
                            arbitration agreement shall be interpreted and
                            enforced in accordance with the Federal Arbitration
                            Act (FAA) set forth in Title 9 of the U.S. Code to
                            the fullest extent possible, notwithstanding any
                            state law to the contrary, regardless of the origin
                            or nature of the Claims at issue. The arbitrator
                            must follow, to the extent applicable: (a) the
                            substantive law of the state in which we entered
                            into the transaction giving rise to this arbitration
                            agreement; (b) the applicable statutes of
                            limitations; and (c) claims of privilege recognized
                            at law. The arbitrator will not be bound by federal,
                            state or local rules of procedure and evidence or by
                            state or local laws concerning arbitration
                            proceedings.
                        </p>
                        <p className="mb-2">
                            If either you or we elect to arbitrate a Claim, the
                            dispute shall be resolved by binding arbitration
                            administered under the applicable rules of the
                            American Arbitration Association (“AAA”). Either you
                            or we may elect to resolve a particular Claim
                            through arbitration, even if the other party has
                            already initiated litigation in court related to the
                            Claim, by: (i) making written demand for arbitration
                            upon the other party, (ii) initiating arbitration
                            against the other party, or (iii) filing a motion to
                            compel arbitration in court.
                        </p>
                        <p className="mb-2">
                            If this is a consumer-purpose transaction, the
                            applicable rules will be the AAA’s Consumer
                            Arbitration Rules. The applicable AAA rules and
                            other information about arbitrating a claim under
                            AAA, including how to submit a dispute to
                            arbitration, may be obtained by visiting its website
                            at{' '}
                            <a
                                className="text-links hover:underline"
                                href="https://www.adr.org/"
                            >
                                https://www.adr.org/
                            </a>{' '}
                            or by calling{' '}
                            <a
                                className="text-links hover:underline"
                                href="tel:18007787879"
                            >
                                1-800-778-7879.
                            </a>{' '}
                            If AAA will not serve as the administrator of the
                            arbitration, and you and we cannot then agree upon a
                            substitute arbitrator, you and we shall request that
                            a court with proper jurisdiction appoint an
                            arbitrator. However, we will abide by the applicable
                            AAA rules regardless of the forum. Arbitration shall
                            be conducted in the county and state where you
                            accepted these Terms of Use, you reside, or another
                            reasonably convenient place to you as determined by
                            the arbitrator, unless applicable laws require
                            another location. Judgment on the award rendered by
                            the arbitrator may be entered in any court having
                            jurisdiction thereof. Except as provided in
                            applicable statutes, the arbitrator’s award is not
                            subject to review by the court and it cannot be
                            appealed. The parties will have the option to
                            request and receive a statement of reasons for the
                            arbitration award.
                        </p>
                        <p className="mb-2">
                            If you elect to file the arbitration, and this is a
                            consumer-purpose transaction, you will pay the
                            filing fee to the extent required by AAA’s Consumer
                            Arbitration Rules but not to exceed the cost of
                            filing a lawsuit. Any amount above what it would
                            cost you to file a lawsuit, we will pay. All other
                            arbitration fees and expenses shall be allocated to
                            us according to AAA rules. Except for the
                            arbitration fees and expenses, each party shall pay
                            its own costs and fees incurred (including
                            attorneys’ fees), unless the arbitrator allocates
                            them differently in accordance with applicable law.
                            This paragraph applies only if this is a
                            consumer-purpose transaction.
                        </p>
                        <p className="mb-2">
                            Notwithstanding anything to the contrary in these
                            Terms of Use, and except as otherwise set forth in
                            this paragraph, the agreement to arbitration may be
                            amended by us only upon advance notice to you. If we
                            make any amendment to this agreement to arbitration
                            (other than renumbering the agreement to align with
                            any other amendment to the Terms of Use) in the
                            future, that amendment shall not apply to any claim
                            that was filed in a legal proceeding or action
                            against us prior to the effective date of the
                            amendment. The amendment shall apply to all other
                            Claims governed by this agreement to arbitration
                            that have arisen or may arise between you and us.
                            However, we may amend this agreement to arbitration
                            and not provide you notice; in that case, the
                            amendments will not apply to you and the agreement
                            to arbitration contained in these Terms of Use to
                            which you agreed will continue to apply to you and
                            us as if no amendments were made.
                        </p>
                        <p className="mb-2">
                            If any part of this arbitration provision is
                            invalid, all other parts of it remain valid.
                            However, if the class action limitation is invalid,
                            then this arbitration provision is invalid in its
                            entirety, provided that the remaining Terms of Use
                            shall remain in full force and effect. This
                            arbitration provision will survive the termination
                            of your use of the Site, the services, and any other
                            actions with us.
                        </p>
                        <p className="mb-2">
                            <b>
                                You may reject this arbitration provision within
                                thirty (30) days of accepting the Terms of Use
                                by emailing us at{' '}
                                <a
                                    className="text-links hover:underline"
                                    href="mailto:privacy@weisigergroup.com"
                                >
                                    privacy@weisigergroup.com.
                                </a>{' '}
                                and including in the subject line “Rejection of
                                Arbitration Provision.”
                            </b>
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>
                                Complete Agreement; Severability; No Third Party
                                Beneficiaries.
                            </b>{' '}
                            These Terms of Use and any agreements governing use
                            of specific portions of the Site constitute the
                            entire understanding between you and Company with
                            respect to the Site and your use thereof,
                            superseding all prior written and oral
                            communications and understandings. If any provisions
                            or portion of these Terms of Use is not given legal
                            effect by a court of competent jurisdiction, such
                            provisions or portions shall drop out of the Terms
                            of Use and the remaining provisions and portions of
                            the Terms of Use shall be construed and enforced.
                            These Terms of Use shall not be interpreted or
                            construed to confer any rights or remedies upon any
                            third parties.
                        </p>
                    </li>
                    <li className="pl-4">
                        <p className="mb-2">
                            <b>Questions.</b> If you have any questions or
                            comments about these Terms of Use or this Site,
                            please contact us by email at{' '}
                            <a
                                className="text-links hover:underline"
                                href="mailto:privacy@weisigergroup.com"
                            >
                                privacy@weisigergroup.com.
                            </a>{' '}
                            You may also write to us at: Weisiger Group Inc,
                            9000 Statesville Road, Charlotte, NC, Attn: Legal
                            Department.
                        </p>
                    </li>
                </ul>
            </div>
        </ContentLayout>
    )
}

export default TermsAndConditionsPage
